import script from "./DetailsLogement.vue?vue&type=script&setup=true&lang=js"
export * from "./DetailsLogement.vue?vue&type=script&setup=true&lang=js"

import "./DetailsLogement.vue?vue&type=style&index=0&id=0ee499ed&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ee499ed"]])

export default __exports__